import { InferType, mixed, object, string } from 'yup'

export interface IParserOptionsSchema {
  stupidediConfig: string
  tfx12ConfigReference: string
  parserLibrary: string
  elementConversionType: string
  documentConversion: string
}

export const ParserOptionsSchema = object<IParserOptionsSchema>({
  stupidediConfig: string().default('default'),
  tfx12ConfigReference: string().default(''),
  parserLibrary: mixed<string>()
    .oneOf(['tfx12', 'stupidedi'])
    .required('Parser Library is required')
    .default('stupidedi'),
  elementConversionType: string().required().default('default'),
  documentConversion: string().required().default('default'),
})

export type TParserOptionsSchema = InferType<typeof ParserOptionsSchema>
